"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isQuizModuleCorrect_1 = __importDefault(require("./isQuizModuleCorrect"));
const quizSessionIncludesModule_1 = __importDefault(require("./quizSessionIncludesModule"));
function updateQuizModulesCorrect({ modulesCorrect }, { session, modules }) {
    return (modulesCorrect +
        modules.filter(module => (0, quizSessionIncludesModule_1.default)(session, module) &&
            (0, isQuizModuleCorrect_1.default)(module)).length);
}
exports.default = updateQuizModulesCorrect;
